import React, { useState, useEffect } from "react";
import { isNeGDDeployment, stopPlayingAudio } from "../../../Actions/Utils";
import { tooltipButtons } from "../../../NewConstants/TooltipConstants";
import { generateSpeech } from "../../../Actions/ChatActions";
import ToastMessage from "../ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import { tooltipImage } from "../../../NewConstants/TooltipConstants";

const TooltipDialog = ({
  heading1,
  heading2,
  speechText,
  text,
  selectedLanguage,
  audioRef,
  index,
  setSpeakerEnabled = () => {},
  stepIndex,
  isSpeakerOn,
  setIsSpeakerOn,
  setStartTour,
  setStepIndex,
  setInput = () => {},
  isLoader = false,
}) => {
  const [showSpeakerIcon, setShowSpeakerIcon] = useState(false);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [image, setImage] = useState("");
  const ImagesKey = Object.keys(tooltipImage);
  const currentImages = tooltipImage[ImagesKey[index - 1]];

  useEffect(() => {
    let imageIndex = 0;
    let interval 
    if(currentImages.length <= 1){
      setImage(currentImages[0]);
    }else{
      interval = setInterval(() => {
        imageIndex = (imageIndex + 1) % currentImages.length;
        setImage(currentImages[imageIndex]);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [currentImages, index]);

  useEffect(() => {
    if (isSpeakerOn) {
      setShowSpeakerIcon(true);
      setShowSpeakerActive(true);
      handleAudio();
    } else {
      setShowSpeakerActive(false);
      setShowSpeakerIcon(false);
    }
  }, [isSpeakerOn]);

  async function handleAudio(){
    if (!speechText) return;
    const res = await generateSpeech(speechText, selectedLanguage);
    if(res?.data?.url){
      const newAudio = new Audio(res.data.url);
      if(audioRef.current){
        stopPlayingAudio(audioRef);
      }
      newAudio.addEventListener("ended", () => {
        setShowSpeakerActive(false);
      });
      audioRef.current = newAudio;
      newAudio.play().catch((err) => {
        console.error("Error playing audio:", err);
      });
    }else{
      setToastErrorMessage(res?.data?.detail || "Audio generation failed");
      setShowToastMessage(true);
    };
  }

  function handleSkip(){
    setStartTour(false);
    setStepIndex(0);
    setSpeakerEnabled(false);
    setInput("");
    if(audioRef.current){
      stopPlayingAudio(audioRef);
    }
  }

  return (
    <div className="w-[100%] rounded-2xl bg-white  p-0 flex flex-col  absolute top-0 left-0 right-0 ">
      {showToastMessage && (
        <ToastMessage
          message={toastErrorMessage}
          severity={ToastSeverityMap.error}
          direction={"bottom"}
          close={setShowToastMessage}
        />
      )}

      <div className="h-[4rem] w-full flex justify-between items-center pr-2">
        <div className="w-8 h-8 flex justify-center items-center ml-2" onClick={handleSkip}> 
          <img src="/Assets/Images/Skip.svg" alt="skip" />
        </div>
        <div className="w-full h-[3rem] flex justify-end items-center" style={{display: isLoader ? "none" : ""}}>
          <div
            className={`flex justify-end items-center 
              ${
              showSpeakerIcon && showSpeakerActive 
                ? isNeGDDeployment()
                  ? "bg-[var(--red-5)] pl-4 rounded-[23px] [color:var(--black)]"
                  : "bg-[var(--active-speaker-div)] pl-4 rounded-[23px] [color:var(--black)]"
                : ""
              }`
            }
            onClick={() => {
              if(showSpeakerActive){
                setIsSpeakerOn(false);
                setShowSpeakerActive(false);
                setShowSpeakerIcon(false);
                stopPlayingAudio(audioRef);
              }else{
                setSpeakerEnabled(false);
                setIsSpeakerOn(true);
                setShowSpeakerActive(true);
                setShowSpeakerIcon(true);
                handleAudio();
              }
            }}
          >
            {showSpeakerIcon && showSpeakerActive
              ? tooltipButtons.stop[selectedLanguage]
              : null}
            {showSpeakerActive ? (
              <div className="">
                <img
                  src={isNeGDDeployment() ? "/Assets/Images/RedSpeaker.svg" : "/Assets/Images/blueSpeaker.svg"}
                  alt="active Speaker"
                  className="w-10 h-10"
                />
              </div>
            ) : (
              <div className="">
                <img
                  src={"/Assets/Images/crossSpeakerIcon.svg"}
                  alt="speaker"
                  className="w-10 h-10"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Main content row */}
      <div
        className="flex h-[8.813rem] items-start gap-0 "
        style={{
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "var(--light-neutral-13)",
          mixBlendMode: "darken",
        }}
      >
        {true && (
          <img src={image} alt={""} className=" h-full" />
        )}
        <div className="h-[100%] w-[70%] flex flex-col justify-center items-center gap-1 [color:var(--tooltip-text)] font-['Anek_Devanagari'] font-bold text-[22px] leading-[23px] tracking-[0px] text-center" style={{backgroundColor: "var(--light-neutral-13)"}}>
          <span className="[color:var(--tooltip-text)]">{heading1}</span>
          <span className="[color:var(--tooltip-text)]">{heading2}</span>
        </div>
      </div>
      <div className="h-[2.875rem] w-full mt-1 px-4 py-2 flex justify-start items-center font-['Anek_Devanagari'] font-normal text-base leading-[20px] tracking-[0px] text-left" style={{color: "var(--dark-neutral-7)" }}>
        {text}
      </div>
    </div>
  );
};

export default TooltipDialog;
